"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isAutoAdded = isAutoAdded;
var _lodash = require("lodash");
var _utils = require("../utils");
function isAutoAdded() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    opt = _ref.opt,
    value = _ref.value,
    allOptions = _ref.allOptions,
    valueKey = _ref.valueKey,
    autoSelectParent = _ref.autoSelectParent,
    autoSelectChildren = _ref.autoSelectChildren;
  var selected = (0, _utils.isSelected)(opt, value, valueKey);
  if (!selected) {
    return false;
  }
  if (autoSelectParent && !autoSelectChildren) {
    if ((0, _utils.hasChildren)(opt)) {
      return (0, _utils.anyChildInValue)(opt, value, valueKey);
    }
    return false;
  }
  if (autoSelectParent && autoSelectChildren) {
    if ((0, _utils.hasChildren)(opt)) {
      var serviceType = (0, _lodash.find)(allOptions, function (o) {
        return o[valueKey] === opt[valueKey];
      });
      return (0, _utils.anyChildInValue)(serviceType, value, valueKey) && !(0, _utils.allChildrenInValue)(serviceType, value, valueKey);
    }
    var parent = (0, _utils.getParent)(opt, allOptions, valueKey);
    return (0, _utils.allChildrenInValue)(parent, value, valueKey);
  }
  return false;
}
var _default = exports["default"] = isAutoAdded;